import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import LoginBgImg from '@/assets/banner.png';
import CalendarIcon from '@/assets/calendar.svg?react';
import DatabaseScriptIcon from '@/assets/database-script.svg?react';
import dayjs from 'dayjs';
import GamesSection from './GamesSection';
import { useGAMouseInteraction } from '@/hooks/useGAMouseInteraction';
import FilesAccessibilityInfoBanner from '@/components/FilesAccessibilityInfoBanner/FilesAccessibilityInfoBanner';

const HomePage = () => {
  const {
    handleMouseEnter: handleNewReleasesMouseEnter,
    handleMouseLeave: handleNewReleasesMouseLeave,
  } = useGAMouseInteraction('new_releases');
  const {
    handleMouseEnter: handleUpcomingReleasesMouseEnter,
    handleMouseLeave: handleUpcomingReleasesMouseLeave,
  } = useGAMouseInteraction('upcoming_releases');

  return (
    <BackgroundWrapper>
      <FilesAccessibilityInfoBanner />
      <div className="page-width-wrapper">
        <Root>
          <Hero>
            <Subtitle>
              <FormattedMessage
                id="homePageSubtitle"
                defaultMessage="Welcome to Rubyplay Partner Portal"
              />
            </Subtitle>
          </Hero>
          <GamesSection
            icon={<DatabaseScriptIcon />}
            titleId="newReleases"
            titleDefaultMessage="Latest Releases"
            queryParams={{
              release_date_to: dayjs().format('YYYY-MM-DD'),
              sort_by: 'release_date',
              sort_order: 'desc',
            }}
            viewAllTo={{
              game_status: ['released'],
              sort_by: 'release_date',
              sort_order: 'desc',
              expandReleaseDate: true,
            }}
            gaSection="latest_releases"
            showLoading={false}
            showExportAction
            onMouseOver={handleNewReleasesMouseEnter}
            onMouseLeave={handleNewReleasesMouseLeave}
          />
          <GamesSection
            icon={<CalendarIcon />}
            titleId="upcomingReleases"
            titleDefaultMessage="Upcoming Releases"
            queryParams={{
              release_date_from: dayjs()
                .add(1, 'day')
                .format('YYYY-MM-DD'),
              sort_by: 'release_date',
              sort_order: 'asc',
            }}
            viewAllTo={{
              game_status: ['coming_soon'],
              sort_by: 'release_date',
              sort_order: 'asc',
              expandReleaseDate: true,
            }}
            gaSection="upcoming_releases"
            rootStyles={{ marginTop: 24 }}
            onMouseOver={handleUpcomingReleasesMouseEnter}
            onMouseLeave={handleUpcomingReleasesMouseLeave}
          />
        </Root>
      </div>
    </BackgroundWrapper>
  );
};

const BackgroundWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.grey200,
}));

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  backgroundColor: theme.palette.grey200,
}));

const Hero = styled('div')(({ theme }) => ({
  height: 400,
  background: `url(${LoginBgImg}) no-repeat center center`,
  backgroundSize: 'cover',
  color: theme.palette.textPrimaryWhite,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  padding: 40,
  borderRadius: theme.radii.xs,
}));

const Subtitle = styled('div')(() => ({
  fontSize: 30,
  lineHeight: '28px',
  fontWeight: 600,
}));

export default HomePage;
